'use strict';

module.exports = document.createElement('div').style;



//////////////////
// WEBPACK FOOTER
// ./node_modules/domkit/builtinStyle.js
// module id = 1241
// module chunks = 81